import { graphql } from 'react-apollo';

import { ProgramCurriculumDomainsQuery } from 'bundles/enterprise-legacy-learner-home/utils/ProgramHomeGraphqlQueries';
import type {
  ProgramCurriculumDomainsQuery as ProgramCurriculumDomainsQueryData,
  ProgramCurriculumDomainsQueryVariables,
} from 'bundles/enterprise-legacy-learner-home/utils/__generated__/ProgramCurriculumDomainsQuery';
import type EnterpriseProgramsV1 from 'bundles/naptimejs/resources/enterprisePrograms.v1';
import type { DomainWithSubdomain, Subdomain } from 'bundles/unified-career-academy/types/enterprise';

type PropsFromCaller = {
  program?: EnterpriseProgramsV1;
};

type PropsFromProgramDomains = {
  domains?: Array<DomainWithSubdomain>;
};

const withEnterpriseProgramDomains = graphql<
  PropsFromCaller,
  ProgramCurriculumDomainsQueryData,
  ProgramCurriculumDomainsQueryVariables,
  PropsFromProgramDomains
>(ProgramCurriculumDomainsQuery, {
  skip: ({ program }) => !program,
  options: ({ program }) => ({
    // The fallback here will never be used due to the skip condition above. This is a bug with react-apollo and ts.
    variables: { programId: program?.id || '1' },
  }),
  props: ({ data }) => {
    const domains = data?.ProgramCurriculumDomainsV1Resource?.get?.domains.filter((domain) => domain !== null);
    const subdomains = data?.SubdomainsV1Resource?.getAll?.elements.filter(
      (subdomain) => subdomain != null
    ) as Array<Subdomain>;

    return {
      domains:
        domains &&
        subdomains &&
        // Include subdomains to be with their domain.
        domains.map((domain) => ({
          ...domain,
          subdomains: subdomains?.filter((subdomain) => subdomain && domain.subdomainIds.includes(subdomain.id)),
        })),
    };
  },
});

export default withEnterpriseProgramDomains;
